<template>
  <div class="main-bg">
    <TopNav></TopNav>
    <TopSearch></TopSearch>
    <div class="main-wrap mt20">
      <div class="fl set-nav">
        <div class="nav-part">
          <p class="nav-title">订单中心</p>
          <ul class="nav-list">
            <router-link tag="li" :to="{path:'/center/order'}" class="active">我的订单</router-link>
          </ul>
        </div>
        <div class="nav-part">
          <p class="nav-title">我的关注</p>
          <ul class="nav-list">
            <router-link tag="li" :to="{path:'/center/followed'}" class="active">关注的店铺</router-link>
          </ul>
        </div>
        <div class="nav-part">
          <p class="nav-title">我的资产</p>
          <ul class="nav-list">
            <router-link tag="li" :to="{path:'/center/wallet'}" class="active">我的钱包</router-link>
          </ul>
        </div>
        <div class="nav-part">
          <p class="nav-title">设置</p>
          <ul class="nav-list">
            <router-link tag="li" :to="{path:'/center/index'}" class="active">个人信息</router-link>
            <router-link tag="li" :to="{path:'/center/address'}" class="active">收货地址</router-link>
          </ul>
        </div>
        <!--<div class="nav-part" v-if="userInfo.shopId">-->
          <!--<p class="nav-title">成为名人</p>-->
          <!--<ul class="nav-list">-->
            <!--<router-link tag="li" :to="{path:'/center/celebrityApply'}" class="active">我的申请</router-link>-->
          <!--</ul>-->
        <!--</div>-->
      </div>
      <div class="fr center-r">
        <router-view/>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>
<script>
  import TopNav from '../../components/header/topNav'
  import TopSearch from '../../components/header/topSearch'
  import Footer from '../../components/footers'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null
          }
      },
      components:{
          TopNav,
          TopSearch,
          Footer
      },
      created () {
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";
  .set-nav{
    .nav-part{
      padding-bottom:39px;
      .nav-title{font-size:19px;color:#222;
        font-weight:600;}
      .nav-list{
        font-size:16px;color:#666666;
        li{
          @include hover-color;
          padding-top:15px;
          &.active.router-link-exact-active{color:$main-color;}
        }
      }
    }
  }
  .center-r{
    width:1100px;
  }
</style>

